import { configurationSettings } from '../../../../configuration/configuration-settings';
import { isSeatFirstOrderingForShowtime } from '../../../browsing/selectors/showtimes/is-seat-first-ordering-for-showtime';
import { getOrderSeatCountForShowtime } from '../seats/get-order-seat-count-for-showtime';
import { getOrderTicketCount } from './get-order-ticket-count';
import { getOrderTicketCountForShowtime } from './get-order-ticket-count-for-showtime';
export const getAllowedOrderTicketCountForShowtime = (showtimeId) => {
    if (isSeatFirstOrderingForShowtime(showtimeId))
        return getOrderSeatCountForShowtime(showtimeId);
    const totalTicketCount = getOrderTicketCount();
    const showtimeTicketCount = getOrderTicketCountForShowtime(showtimeId);
    const { maximumTicketsPerOrder } = configurationSettings.data.order;
    return maximumTicketsPerOrder - totalTicketCount + showtimeTicketCount;
};
